<template>
  <div class="product__modal" @click.stop="emit('toggle-bis-modal')">
    <div id="form-bis" class="product__content" @click.stop>
      <div class="product__content-exit" @click.stop="emit('toggle-bis-modal')">
        <svg class="icon icon--xl"><use href="#x"></use></svg>
      </div>
      <div class="text-component">
        <h3>{{ product.back_in_stock_modal.modal_header }}</h3>
        <p><span v-html="decodeHtml(product.back_in_stock_modal.modal_message_before_product_title)"></span> {{ variantTitle() }}{{ product.product_title }} <span v-html="decodeHtml(product.back_in_stock_modal.modal_message_after_product_title)"></span></p>
      </div>
      <div class="form-wrapper">
        <form id="bis-signup" class="klaviyo-form klaviyo_gdpr_embed_RySXjt" action="//manage.kmail-lists.com/subscriptions/subscribe" data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" target="_blank">
          <input type="hidden" name="g" value="RySXjt">
          <input type="hidden" name="$fields" value="waitlist_sku"/>
          <input type="hidden" id="waitlist_sku" name="waitlist_sku" :value="selectedVariant.sku">
  
          <div class="form-line form-line--float-label">
            <input class="" type="email" value="" name="email" id="k_id_email" placeholder="Your email" required/>
          </div>
  
          <p class="success_message" style="display:none;"></p>
          <div class="error_message" style="display:none;"></div>
  
          <div class="klaviyo_form_actions">
            <button type="submit" class="btn btn--primary">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { onMounted } from 'vue';

  const emit = defineEmits(['toggle-bis-modal'])

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    selectedVariant: {
      type: Object,
      default: () => ({})
    },
  })

  onMounted(() => {
    attachKlaviyoForm()
  })

  const attachKlaviyoForm = () => {
    if(KlaviyoSubscribe) {
      KlaviyoSubscribe.attachToForms('#bis-signup', {
        hide_form_on_success: true,
        success_message: "Thanks! We'll let you know when we're back in stock.",
        success: function($form) {
          $('#form-bis .text-component p').hide();

          var email = $form.find('[name="email"]').val();
          var date = new Date();
          var properties = {
            "waitlist_sku": $("#waitlist_sku").attr('value'),
            "submitted_at": date.toISOString().split("T")[0]
          }

          // Send Klaviyo Event
          sendEvent('Joined Out Of Stock Waitlist', email, properties);

        },
        extra_properties: {
          $source: '$embed',
          $method_type: "Klaviyo Form",
          $method_id: 'embed',
          $waitlist_sku: $("#waitlist_sku").attr('id')
          // $consent_version: 'Embed default text'
        }
      });
    }
  }

  const sendEvent = (event, email, properties) => {
    var body = {
      "token": "RpLQJY",
      "event": event,
      "customer_properties": {
        "$email": email
      },
      "properties": properties
    }
    var encoded_data = btoa(JSON.stringify(body));

    return axios({
      method: 'GET',
      url: 'https://a.klaviyo.com/api/track?data='+encoded_data,
    }).then(function(response) {
      console.log({ "Successfully sent event to Klaviyo": response.data })
    }).catch(function(err) {
      sendResult(400, { "Error updating Klaviyo": err })
    });
  }

  const decodeHtml = (str) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  const variantTitle = () => {
    const txt = props.product.options[0].selected;
    return txt !== 'Default title' ? txt + ' ' : '';
  }

</script>